const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

function matchesCollection(product, collection) {
  const text = normalize([product.name, product.category, product.subcategory, product.brand].join(' '));
  const category = normalize(product.category);
  if (collection.kind === 'brand') {
    const aliases = { kieslect: /\bkie(?:s|se)lect\b/, soundpeats: /\bsound\s*peats?\b/ };
    return (aliases[collection.search] || new RegExp(`\\b${collection.search}\\b`)).test(text);
  }
  if (collection.kind === 'phones') return /\b(iphone|smartphone|telephone|redmi)\b/.test(text) && !/chargeur|charger|cable|coque|case|support|ecouteur|earbud|watch|montre|traceur|finder/.test(text);
  if (collection.kind === 'audio') return /airpods|ecouteur|earbud|\bbuds\b/.test(text);
  if (collection.kind === 'chargers') return /chargeur|charger|cable/.test(text) && !/power\s*bank|batterie externe/.test(category);
  if (collection.kind === 'watches') return /watch|montre/.test(text);
  if (collection.kind === 'powerbanks') return /power\s*bank|powerbank|batterie externe/.test(text);
  if (collection.kind === 'gps') return /gps|traceur|localisateur|finetrack|finder/.test(text) && !/watch|montre/.test(category);
  return false;
}

module.exports = { matchesCollection };
